module.exports = __webpack_public_path__ + "img/mirka_group_logo.a26be94c.jpg";